import React, { useState } from "react";
import { connect } from "react-redux";
import { withTranslation, Trans } from "react-i18next";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Divider from "@material-ui/core/Divider";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";

import { setSelectedComponentObject } from "../../redux/actions/appActions";


const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  inline: {
    display: "inline",
  },
}));

function KnowYourRightsList(props) {
  const classes = useStyles();
  let history = useHistory();
  let menuItem = props.KnowYourRightsObj.contentList[0];
  const { t } = props;

  function handleClick() {
    if(props.KnowYourRightsObj.hasChild) {
      if(props.KnowYourRightsObj.contentId == 97) {
        props.setSelectedComponentObject({id: props.KnowYourRightsObj.contentId});
        history.push({
          pathname: "/layout/kyrchild",
          state: {id: props.KnowYourRightsObj.contentId},
        });  
      } else {
        history.push({
          pathname: "/layout/getknowyourrightsdetail",
          state: props.KnowYourRightsObj,
        });
      }
    } else {
      history.push({
        pathname: "/layout/getknowyourrightsdetail",
        state: props.KnowYourRightsObj,
      });
    }
    
  }


  function getHttpsUrl(iconurl) {
    var spliurtl = iconurl.split("://")
    let myUrl = spliurtl.length > 1 ? "https://" + spliurtl[1] : "https://" + spliurtl[0];
    return myUrl;
  }


  if(!menuItem) {
    return <>
      <ListItem alignItems="flex-start">
        <ListItemAvatar>
          <Avatar
            alt={props.KnowYourRightsObj & props.KnowYourRightsObj.contentName}
          />
        </ListItemAvatar>
        <ListItemText
          primary={props.KnowYourRightsObj && props.KnowYourRightsObj.contentName}
          className="infotitle"
          secondary={
            <React.Fragment>
              <Typography
                component="span"
                variant="body2"
                className="infodesc"
                color="textPrimary"
              >
                {props.KnowYourRightsObj.shortDesc}
              </Typography>
              {props.KnowYourRightsObj.hasChild &&
                <Typography
                  component="span"
                  variant="body2"
                  className={classes.inline}
                  color="textPrimary"
                >
                  <Button
                    style={{ background: props.componentbgcolor }}
                    variant="contained"
                    color="primary"
                    disableElevation
                    className="infoviewmorebtn"
                    onClick={handleClick}
                  >
                     <Trans> {t("View More")} </Trans>
                  </Button>
                </Typography>
              }
            </React.Fragment>
          }
        />
      </ListItem>
      <Divider variant="inset" component="li" />
    </>;
  }


  return (
    <>
      <ListItem alignItems="flex-start">
        <ListItemAvatar>
          <Avatar
            alt={menuItem & menuItem.title ? menuItem.title : ""}
            src={menuItem.logoURL ? getHttpsUrl(menuItem.logoURL) : ""}
          />
        </ListItemAvatar>
        <ListItemText
          primary={menuItem && menuItem.title}
          style={{ color: props.componentbgcolor }}
          className="infotitle"
          secondary={
            <React.Fragment>
              <Typography
                component="span"
                variant="body2"
                className="infodesc"
                color="textPrimary"
              >
                {menuItem.shortDesc}
              </Typography>
              <Typography
                component="span"
                variant="body2"
                className="infoupdatedate"
                color="textPrimary"
              >
                {menuItem.date}
              </Typography>
              <Typography
                component="span"
                variant="body2"
                className={classes.inline}
                color="textPrimary"
              >
                <Button
                 style={{ background: props.componentbgcolor }}
                  variant="contained"
                  color="primary"
                  disableElevation
                  className="infoviewmorebtn"
                  onClick={handleClick}
                >
                   <Trans> {t("View More")} </Trans>
                  
                </Button>
              </Typography>
            </React.Fragment>
          }
        />
      </ListItem>
      <Divider variant="inset" component="li" />
    </>
  );
}

const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    communityuid: storeState.communityId,
    langId: storeState.langId,
    componentbgcolor: storeState.componentbgcolor
  };
};


export default connect(mapStateToProps, { setSelectedComponentObject })(withTranslation()(KnowYourRightsList));